var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.appMobile())?_c('div',{staticClass:"nav-container"},[_c('img',{attrs:{"src":require("@/assets/images/ic_navigation.svg")},on:{"click":_vm.navOpen}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }